export class UserSearchRequest {
  FirstName?: string;
  LastName?: string;
  UserPrincipalName?: string;
}

export class UserSearchResult {
  DisplayName?: string;
  GivenName?: string;
  Surname?: string;
  Mail?: string;
  EmployeeId?: string;
  JobTitle?: string;
  UserPrincipalName?: string;
  MobilePhone?: string;
}
